import { AdminAngularAntdModule } from './angular-antd.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxImageCompressService } from 'ngx-image-compress';

import { AdminAnswerComponent } from '../components/form-builder/answer/answer.component';
import { FormEngineComponent } from '../components/form-builder/form-engine/form-engine.component';
import { QuestionComponent } from '../components/form-builder/question/question.component';
import { WeightHeightComponent } from '../components/common/weight-height/weight-height.component';
import { BmiComponent } from '../components/common/bmi/bmi.component';

import { BoolPipe } from '../pipes/bool.pipe';
import { FilePipe } from '@care-portals/ui';

@NgModule({
  declarations: [
    AdminAnswerComponent,
    FormEngineComponent,
    QuestionComponent,
    WeightHeightComponent,
    BmiComponent
  ],
  providers: [NgxImageCompressService],
  imports: [
    CommonModule,
    FormsModule,
    AdminAngularAntdModule,
    BoolPipe,
    FilePipe
  ],
  exports: [AdminAnswerComponent, FormEngineComponent]
})
export class FormBuilderModule {}
